<template>
    <v-card class="floor-dialog">
        <v-card-title class="text-h5">
            Δομή Κτιρίου
        </v-card-title>

        <v-card-text class="card-text">
            Η δομή του κτιρίου μέσα από το αρχείο της Προδέσμευσης
        </v-card-text>
        <div v-if="editMode" class="floor-buttons-wrapper">
            <v-btn
                class="addition-btn"
                outlined
                color="green"
                small
                @click="addFloor"
            >
                <v-icon small>mdi-plus</v-icon>
                ΠΡΟΣΘΗΚΗ ΟΡΟΦΟΥ
            </v-btn>
            <v-btn
                v-if="this.buldingStructure.length > 1"
                class="addition-btn"
                outlined
                color="red"
                small
                @click="removeFloor"
            >
                <v-icon small>mdi-minus</v-icon>
                ΑΦΑΙΡΕΣΗ ΟΡΟΦΟΥ
            </v-btn>
        </div>
        <div class="floor-group-wrapper">
            <div v-for="floor of buldingStructure" :key="floor.floor" class="floor-wrapper">
                <div class="label-wrapper">
                    <h4 class="mr-2">{{ floor.floor }}</h4>Όροφος
                    <!-- <span v-if="!isNaN(floor.floor)"> Όροφος</span> -->
                </div>
                <v-select
                    v-if="editMode"
                    v-model="floor.floor"
                    :items="remainingFloors"
                    label="Επιλογή Ορόφου"
                    class="floor-input"
                    prepend-icon="mdi-domain"
                    :readonly="!editMode"
                ></v-select>
                <div class="quantity-input-wrapper">
                    <v-text-field
                        v-model="floor['apartments']"
                        outlined
                        single-line
                        :rules="apartmentRules"
                        class="quantity-input"
                        :suffix="'διαμ.'"
                        :readonly="!editMode"
                    ></v-text-field>
                    <v-text-field
                        v-model="floor['stores']"
                        outlined
                        single-line
                        :rules="apartmentRules"
                        class="quantity-input"
                        :suffix="'κατ.'"
                        :readonly="!editMode"
                    ></v-text-field>
                </div>
            </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="editMode" class="mx-2 white--text" :loading="loading" large color="black" @click="onFloorStructureSubmit">
                ΥΠΟΒΟΛΗ
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    export default {
        props: {
            editMode: {
                type: Boolean,
                required: true
            },
            stored: {
                type: Array,
                required: true
            }
        },
        watch: {
            stored: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.buldingStructure = newVal
                    } else {
                        this.buldingStructure = [{ floor: 'Ισόγειο', stores: 0, apartments: 0 }]
                    }
                },
                immediate: true
            }
        },
        computed: {
            selectedFloors() {
                return this.buldingStructure.map(f => f.floor)
            },
            remainingFloors() {
                const available = [ ...this.floorSelections ]
                for (let floor of this.selectedFloors) {
                    const index = available.indexOf(floor)
                    available.splice(index, 1)
                }
                return available
            }
        },
        data() {
            return {
                apartmentRules: [
                    v => (!isNaN(v)) || 'Το πεδίο θα πρέπει να είναι αριθμός',
                    v => (v !== '') || 'Το πεδίο είναι υποχρεωτικό'
                ],
                floorRules: [
                    v => (!isNaN(v)) || 'Το πεδίο θα πρέπει να είναι αριθμός',
                    v => (v !== '') || 'Το πεδίο είναι υποχρεωτικό',
                    v => !this.buldingStructure.find(f => f.floor === v) || 'Ο όροφος έχει ήδη επιλεγεί'
                ],
                loading: false,
                buldingStructure: [],
                floorSelections: [-5, -4, -3, -2, 'Υπόγειο', 'Ημιυπόγειο', 'Ισόγειο', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            }
        },
        methods: {
            removeFloor() {
                this.buldingStructure.pop()
                this.buldingStructure = [ ...this.buldingStructure ]
            },
            addFloor() {
                this.buldingStructure.push({ floor: '', stores: 0, apartments: 0 })
            },
            onFloorStructureSubmit() {
                this.buldingStructure = this.buldingStructure.filter(structure => structure.floor !== '')
                this.$emit('floorStructureUpdate', this.buldingStructure)
            }
        }
    }
</script>
<style scoped>
.floor-buttons-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.quantity-input {
    padding: 0.2rem;
}
.addition-btn {
    margin-left: 1.2rem;
    margin-bottom: 1.2rem;
}
.quantity-input-wrapper {
    display: flex;
    width: 80%;
    margin: 0 auto;
}
.floor-group-wrapper {
    max-height: 350px;
    overflow-y: auto;
}

.floor-number {
    padding: 0.2rem;
    padding-bottom: 1.8rem;
}

.floor-input {
    width: 80%;
    margin: 0 auto;
}

.floor-wrapper {
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: 0 auto;
    margin-bottom: 1rem;
    border: solid var(--cards-and-tables-text-color) 1px;
    border-radius: 10px;
}

.card-text {
    color: var(--cards-and-tables-text-color) !important;
}

.label-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    margin-top: 0.8rem;
}

</style>
